import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AppRoutes } from '../constants/route';
import { useUserAccess } from '../hooks/useUserAccess';

interface RoleGuardProps {
  allowedRoles: string[];
  fallbackPath?: string;
}

const RoleGuard: React.FC<RoleGuardProps> = ({
  allowedRoles,
  fallbackPath = AppRoutes.changeRequests.path,
}) => {
  const { hasAdminAccess } = useUserAccess();

  if (!hasAdminAccess) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <Outlet />;
};

export default RoleGuard;
